import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import {
  GetIngestionDocumentFragment,
  VariableSource,
} from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { ComplianceValidationVariant } from '../ComplianceDrawer';
import { formatInputValuesForTooltip } from '../utils/validation.utils';

interface ValidationTooltipContentProps {
  inputValues?: Array<{
    variableSource?: VariableSource;
    fieldKey: string;
    value: string;
  }>;
  selectedDocument?: GetIngestionDocumentFragment | null;
  variant?: ComplianceValidationVariant;
}

export const ValidationTooltipContent: FC<ValidationTooltipContentProps> = ({
  inputValues,
  selectedDocument,
  variant = 'external',
}) => {
  if (!inputValues || inputValues.length === 0) {
    return null;
  }

  const { fromContract, externalReference } = formatInputValuesForTooltip(
    inputValues,
    selectedDocument,
    variant
  );

  if (fromContract.length === 0 && externalReference.length === 0) {
    return null;
  }

  return (
    <VStack align="stretch" spacing={3}>
      {fromContract.length > 0 && (
        <Box>
          <Heading
            color="compliance.validation.tooltip.text.primary"
            mb={2}
            size="smallUppercase"
          >
            From Contract
          </Heading>
          {fromContract.map((item, index) => (
            <Flex
              key={index}
              alignItems="flex-start"
              fontSize="sm"
              gap={1}
              justify="space-between"
              minW={0}
            >
              <Text
                fontWeight="medium"
                minW="90px"
                whiteSpace="normal"
                wordBreak="break-word"
              >
                {item.label}:{' '}
              </Text>
              <Text minW={0} whiteSpace="normal" wordBreak="break-word">
                {item.value}
              </Text>
            </Flex>
          ))}
        </Box>
      )}
      {externalReference.length > 0 && (
        <Box>
          <Heading
            color="compliance.validation.tooltip.text.primary"
            mb={2}
            size="smallUppercase"
          >
            External Reference Data
          </Heading>
          {externalReference.map((item, index) => (
            <Flex
              key={index}
              alignItems="flex-start"
              fontSize="sm"
              gap={1}
              justify="space-between"
              minW={0}
            >
              <Text
                fontWeight="medium"
                minW="90px"
                whiteSpace="normal"
                wordBreak="break-word"
              >
                {item.label}:{' '}
              </Text>
              <Text minW={0} whiteSpace="normal" wordBreak="break-word">
                {item.value}
              </Text>
            </Flex>
          ))}
        </Box>
      )}
    </VStack>
  );
};
